import { createContext, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import View from '../../../../geometry/view';
import { updateGeometry } from '@/store/actions/typemark';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { ErrorBoundary } from 'react-error-boundary';
import WrongGeometryFallback from '../WrongGeometryFallback';

export const CameraContext = createContext<any>(undefined);

const UpdateGeometryModal = ({
  visible,
  typeMarkId,
  onClose,
  geometry,
  layers,
  editable,
  position,
  perspective,
  zoom,
}) => {
  const dispatch = useDispatch();
  const [cameraState, setCameraState] = useState();
  const [layersState, setLayersState] = useState(layers ?? []);
  const [isPerspective, setIsPerspective] = useState(perspective);

  const handleCameraChange = (camera) => {
    setCameraState(camera);
  };

  const handleChangeLayerVisibility = (layer) => {
    const list = [...layersState];
    const index = layersState?.findIndex(({ name }) => name === layer.name);

    list[index] = layer;

    setLayersState(list);
  };

  const handleConfirm = () => {
    dispatch(
      updateGeometry(typeMarkId, {
        camera_position: JSON.stringify((cameraState as any)?.matrix?.toArray()),
        visible_layers: layersState ?? [],
        perspective: isPerspective,
        camera_zoom: (cameraState as any)?.zoom,
      })
    );
    onClose();
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editace</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex w-full items-center">
            <h3 className="text-sm mb-2 shrink-0 mr-2">Typ kamery:</h3>
            <div className="flex justify-center items-center mb-2 w-full">
              <button
                className={classNames('flex-1 bg-color4 border h-10', {
                  ' bg-color7 text-white': !isPerspective,
                })}
                data-testid="typemark-geometry-modal-orthogonal-btn"
                onClick={() => setIsPerspective(false)}
              >
                Ortogonální
              </button>
              <button
                className={classNames('flex-1 bg-color4 border h-10', {
                  'bg-color7 text-white': isPerspective,
                })}
                data-testid="typemark-geometry-modal-perspective-btn"
                onClick={() => setIsPerspective(true)}
              >
                Perspektivní
              </button>
            </div>
          </div>
          <ErrorBoundary fallback={<WrongGeometryFallback />}>
            <View
              geometry={geometry}
              position={position}
              layers={layersState}
              zoom={zoom}
              editable={editable}
              canvasId="threeModal"
              cameraType={isPerspective ? 'perspective' : 'orthogonal'}
              submit={() => {}}
              onCameraChange={handleCameraChange}
              onChangeLayerVisibility={handleChangeLayerVisibility}
              withControlPanel
              controlPanel={<button data-testid="typemark-geometry-modal-front-btn">front</button>}
            />
          </ErrorBoundary>
        </DialogBody>
        <DialogFooter>
          <Button key={1} data-testid="typemark-geometry-modal-submit-btn" onClick={handleConfirm}>
            Potvrdit
          </Button>
          <Button
            key={2}
            variant="outline"
            data-testid="typemark-geometry-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateGeometryModal;
